
export const baseURL = "https://apicustomerportalsaas.cladev.com/web/api/";
export const IDSERVER = "https://idsrvsaas.cladev.com";
export const CLASERVER = "https://apisaasnovus.azurewebsites.net/api/";
export const MYREWARDS = "https://apiloyalty.novusloyalty.com/web/api/"